import React from 'react';
import { motion } from 'framer-motion';
const CEO_IMG = 'https://cdn.magicpatterns.com/uploads/4Pt8wgiecBMMAw2639TFSC/Ally.webp';
export function About() {
  return <section id="about" className="w-full bg-slate-50" data-id="element-16" data-mp="2ptbhice3fvdn">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-24" data-id="element-17" data-mp="2tsam1vvwxq4k">
        <div className="flex flex-row items-center" data-id="element-18" data-mp="2yrwuzt4pkk7k">
          <motion.div initial={{
          opacity: 0,
          x: -24
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.6
        }} className="relative w-1/2 shrink-0 pr-3" data-id="element-19" data-mp="2ytgertpkpde3">
            <div className="overflow-hidden rounded-[2rem] shadow-2xl shadow-slate/20" data-id="element-20" data-mp="3mhrakigewmvi">
              <img src={CEO_IMG} alt="Ally, founder of Ally Cleaning Boutique NYC" className="h-full w-full object-cover" data-id="element-21" data-mp="3mfwmiv9ugen7" />
            </div>
            <div className="absolute -bottom-6 -right-2 rounded-2xl bg-white px-6 py-4 shadow-xl ring-1 ring-slate-100 sm:-right-6" data-id="element-22" data-mp="2lourz4yasnea">
              <p className="font-display text-2xl font-extrabold text-magenta" data-id="element-23" data-mp="2cpr65t7qxtw3">
                10+ yrs
              </p>
              <p className="text-xs font-medium uppercase tracking-wide text-slate-muted" data-id="element-24" data-mp="27sra8b4m27ip">
                Serving NYC homes
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 24
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.6
        }} className="w-1/2 shrink-0 pl-3" data-id="element-25" data-mp="30fvc478eq5q9">
            <span className="text-xs font-semibold uppercase tracking-[0.2em] text-magenta" data-id="element-26" data-mp="3je7l9szbjflu">
              About Ally
            </span>
            <h2 className="mt-3 font-display text-3xl sm:text-4xl font-extrabold tracking-tight text-slate" data-id="element-27" data-mp="686gawosysuk">
              The Heart Behind the Clean: Ally&apos;s Story
            </h2>
            <p className="mt-6 text-lg leading-relaxed text-slate-soft" data-id="element-28" data-mp="3tgtorwflecx6">
              With over 10 years of experience serving New York&apos;s most
              exclusive homes, Ally understands that a clean house is more than
              just organized—it&apos;s a sanctuary. Growing up with a passion
              for order and hospitality, she transformed her dedication into a
              premium boutique service. Ally isn&apos;t just your cleaner; she
              is your strategic partner in home maintenance.
              <br data-id="element-29" data-mp="18sykc3sjb0ub" />
              <br data-id="element-30" data-mp="18sfdbi4f9wv2" />
              Known for her meticulous attention to detail and absolute
              discretion, Ally has built a loyal clientele of busy professionals
              and families who trust her with their most private spaces. Her
              philosophy is simple: Luxury is found in the details others miss.
              Whether it&apos;s a pre-event deep clean or your weekly
              maintenance, Ally treats every apartment like a masterpiece.
            </p>
            <div className="mt-8 flex flex-col gap-4 sm:flex-row" data-id="element-31" data-mp="32aw6gmmeq4r6">
              {[['Eco-friendly', 'Safe for kids, pets & the planet'], ['Fully vetted', 'Trained, insured & background-checked']].map(([title, sub]) => <div key={title} className="flex-1 rounded-2xl bg-white p-5 ring-1 ring-slate-100" data-id="element-32" data-mp="3c3jzd6a9nokm">
                  <p className="font-display font-bold text-slate" data-id="element-33" data-mp="3l374a227fcif">{title}</p>
                  <p className="mt-1 text-sm text-slate-muted" data-id="element-34" data-mp="1vmfuuwu1n166">{sub}</p>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}